/**
 * @generated SignedSource<<74cb3ffe353b0418cba21d923780ff24>>
 * @relayHash 9a46cf9cad10935da85155f5e8461f8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf7ec06dca03e54b883b5055e3d245033c4636cfb76197a5dd359ffecd403d38

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalProductsSettingsSidebarQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
  skipJsmAdminCheck: boolean;
  skipSiteWfoStatus: boolean;
};
export type GlobalProductsSettingsSidebarQuery$data = {
  readonly jsmAdmin?: {
    readonly hasJsmAdminAccess: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DelegatedAdminJiraSection" | "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts">;
};
export type GlobalProductsSettingsSidebarQuery = {
  response: GlobalProductsSettingsSidebarQuery$data;
  variables: GlobalProductsSettingsSidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipDelegatedAdminCheck"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipJsmAdminCheck"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipSiteWfoStatus"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "condition": "skipJsmAdminCheck",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": "jsmAdmin",
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": (v5/*: any*/),
          "kind": "ScalarField",
          "name": "hasJsmAdminAccess"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GlobalProductsSettingsSidebarQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          {
            "kind": "Variable",
            "name": "skipDelegatedAdminCheck",
            "variableName": "skipDelegatedAdminCheck"
          }
        ],
        "kind": "FragmentSpread",
        "name": "DelegatedAdminJiraSection"
      },
      {
        "args": [
          (v4/*: any*/),
          {
            "kind": "Variable",
            "name": "skipSiteWfoStatus",
            "variableName": "skipSiteWfoStatus"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts"
      },
      (v6/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GlobalProductsSettingsSidebarQuery",
    "selections": [
      {
        "condition": "skipDelegatedAdminCheck",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "canManageCustomOnboarding",
                "args": [
                  (v4/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "MANAGE_CUSTOM_ONBOARDING"
                  }
                ],
                "kind": "ScalarField",
                "name": "hasGlobalPermission"
              }
            ]
          }
        ]
      },
      {
        "condition": "skipSiteWfoStatus",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "AgentWorkspaceSiteWfoStatus",
            "kind": "LinkedField",
            "name": "agentWorkspace_siteWfoStatus",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasProjectEnabledWfo"
              },
              {
                "kind": "ScalarField",
                "name": "hasProjectFinishOnboarding"
              }
            ]
          }
        ]
      },
      (v6/*: any*/)
    ]
  },
  "params": {
    "id": "bf7ec06dca03e54b883b5055e3d245033c4636cfb76197a5dd359ffecd403d38",
    "metadata": {},
    "name": "GlobalProductsSettingsSidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "07d462f66798305f57e9dcfa3a91daf3";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
